module.exports = __webpack_public_path__ + "static/media/img-tv.b86d70c1.svg";